import { render, staticRenderFns } from "./real-name.vue?vue&type=template&id=f477e764&scoped=true"
import script from "./real-name.vue?vue&type=script&lang=js"
export * from "./real-name.vue?vue&type=script&lang=js"
import style0 from "./real-name.vue?vue&type=style&index=0&id=f477e764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f477e764",
  null
  
)

export default component.exports